module.exports = __webpack_public_path__ + "img/arrow-bottom.ff607ec5.svg";